// extracted by mini-css-extract-plugin
export default {"container":"AboutPage_container__639RD"};